import { kebabCase } from 'lodash';
import { useQuery } from 'react-query';

import {
  NEWSLETTER_SUBSCRIPTIONS_KEY,
  Newsletter,
  NewsletterSubscription,
  getNewsletterSubscriptions,
} from '../utils/backend-api/newsletters';

const buildNewsletter = (newsletters?: Newsletter[]): NewsletterSubscription[] => {
  if (!newsletters) return undefined;
  return newsletters.map((newsletter) => ({
    accessLevel: newsletter.access_level,
    author: newsletter.author,
    frequency: newsletter.frequency,
    isPro: newsletter.is_pro_only,
    isSubscribed: newsletter.current_user_subscribed,
    newsletterId: newsletter.id,
    offerCode: newsletter.offer_code,
    slug: kebabCase(newsletter.name),
    subheader: newsletter.description,
    title: newsletter.name,
  }));
};

export default function useNewsletterSubscriptions() {
  const { data, isLoading: isLoadingNewsletterSubscriptions } = useQuery<Newsletter[]>(
    NEWSLETTER_SUBSCRIPTIONS_KEY,
    () => getNewsletterSubscriptions()
  );

  return { newsletters: buildNewsletter(data), isLoadingNewsletterSubscriptions };
}
